import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.217 3.522c1.434-.837 3.105-1.175 4.751-.96 1.647.214 3.175.968 4.347 2.145 1.171 1.176 1.92 2.708 2.127 4.356.057.456-.266.873-.723.93-.457.058-.873-.266-.93-.722-.162-1.282-.744-2.473-1.655-3.388s-2.1-1.502-3.38-1.669c-1.281-.167-2.581.096-3.696.747-.737.43-1.366 1.014-1.847 1.706H7.5c.46 0 .833.373.833.833 0 .46-.373.833-.833.833H3.333c-.46 0-.833-.373-.833-.833V3.333c0-.46.373-.833.833-.833.46 0 .834.373.834.833v1.95c.567-.701 1.26-1.3 2.05-1.761zM3.28 10.007c.457-.058.874.265.932.722.162 1.28.744 2.471 1.655 3.386.912.914 2.1 1.501 3.38 1.668 1.28.166 2.58-.096 3.695-.747.737-.43 1.365-1.012 1.847-1.703H12.5c-.46 0-.833-.373-.833-.833 0-.46.373-.833.833-.833h4.167c.46 0 .833.373.833.833v4.167c0 .46-.373.833-.833.833-.46 0-.834-.373-.834-.833v-1.952c-.567.702-1.26 1.3-2.05 1.76-1.434.837-3.105 1.175-4.75.96-1.646-.214-3.175-.968-4.346-2.144-1.172-1.175-1.92-2.706-2.129-4.353-.058-.457.266-.874.722-.931z",
  "clip-rule": "evenodd"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}